import { AuthScreen } from '@raas/components/b2b/auth-screen';
import { Cpu } from 'lucide-react';
import { useLocation } from 'react-router-dom';
import { activateFirstOrganization, signIn } from './auth';

export default function ServiceAuthScreen() {
  const returnTo =
    new URLSearchParams(useLocation().search).get('returnTo') ?? '/market';

  return (
    <AuthScreen
      icon={<Cpu className="size-6" />}
      title="TensorPod"
      subtitle="弹性算力平台"
      returnTo={returnTo}
      onLogin={async (email, password) => {
        const result = await signIn.email({ email, password });
        if (result.error) {
          return { error: result.error.message ?? '登录失败' };
        }
        await activateFirstOrganization();
        return {};
      }}
    />
  );
}
